import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Link } from 'react-router-dom';
import { API_URL, LOCATION_ID, TOKEN } from '..';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const InvoiceListLayer = ({ jobsData }) => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [paymentLogs, setPaymentLogs] = useState([]);
  const [tableError, setTableError] = useState('');
  const [selectedStatusFor, setSelectedStatusFor] = useState(null)
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [receivedAmount, setReceivedAmount] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('CONFIRM');
  const [showModal, setShowModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  // Memoize privileges to prevent re-creation on every render
  const privileges = useMemo(() => {
    const storedPrivileges = localStorage.getItem('privilages');
    return storedPrivileges
      ? JSON.parse(storedPrivileges)
      : { invoice: { edit: false, delete: false, read: false, changeStatus: false } };
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await fetch(`${API_URL}/api/accounts/location/${LOCATION_ID}`, {
        method: 'GET',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (response.status === 200) {
        if (!Array.isArray(data.accounts)) {
          throw new Error('Invalid data format: accounts is not an array');
        }
        setAccounts(data.accounts || []);
        setTableError('');
      } else {
        throw new Error(data.message || 'Failed to fetch accounts');
      }
    } catch (err) {
      console.error('Fetch accounts error:', err);
      setTableError(err.message || 'Unable to load accounts. Please try again.');
      setAccounts([]);
      toast.error(err.message || 'Unable to fetch accounts', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleDelete = async (id) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      navigate('/sign-in');
      return;
    }
    try {
      let headersList = {
        Accept: '*/*',
        'Content-Type': 'application/json',
      };
      let response = await fetch(`${API_URL}/api/invoice/delete-invoice/${id}`, {
        method: 'DELETE',
        headers: headersList,
      });
      let data = await response.json();
      if (data.message === 'Invoice deleted successfully') {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Invoice deleted successfully!',
        });
        window.location.reload();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data.message || 'Failed to delete invoice',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete invoice: ' + error.message,
      });
    }
  };
  const fetchPaymentLogs = async (invoiceId) => {
    try {
      const response = await fetch(`${API_URL}/api/payments/invoice/${invoiceId}`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (!response.ok) {
        console.error("Failed to fetch logs:", data.message);
        setPaymentLogs([]);
        return;
      }

      // ✅ Enhance logs with user info
      const logsWithUsers = await Promise.all(
        data.map(async (log) => {
          try {
              const options = {
                  method: 'GET',
                  url: 'https://services.leadconnectorhq.com/users/'+log.user_id,
                  headers: {
                    Authorization: `Bearer ${TOKEN}`,
                    Version: '2021-07-28',
                    Accept: 'application/json'
                  }
                };
                
                try {
                  const { data } = await axios.request(options);
                  console.log(data);
                  return {
                      ...log,
                      userName: `${data.firstName || ""} ${data.lastName || ""}`.trim(),
                  };
              } catch (error) {
                  console.error(error);
                }

          //   const userData = await userRes.json();
         
          } catch (err) {
            console.error("User fetch error:", err);
            return { ...log, userName: "Unknown User" };
          }
        })
      );

      setPaymentLogs(logsWithUsers);
    } catch (error) {
      console.error("Error fetching payment logs:", error);
      setPaymentLogs([]);
    } 
  };

  const handleStatusChange = async (id, newStatus) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      navigate('/sign-in');
      return;
    }
    try {

      if (newStatus === 'paid' || newStatus == 'partially-paid') {
        const invoice = jobsData.find((job) => job.id === id);
        setSelectedInvoice(invoice);
        setSelectedStatusFor(newStatus)
        await fetchAccounts();
        await fetchPaymentLogs(invoice?.id)
        setShowModal(true);
      }else{
        let headersList = {
          Accept: '*/*',
          'Content-Type': 'application/json',
        };
        let response = await fetch(`${API_URL}/api/invoice/update-status/${id}`, {
          method: 'PUT',
          headers: headersList,
          body: JSON.stringify({ status: newStatus }),
        });
        let data = await response.json();
        if (data.message === 'Invoice successfully updated') {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Invoice status updated successfully!',
          });
          window.location.reload();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: data.message || 'Failed to update invoice status',
          });
        }
      }
    
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update invoice status: ' + error.message,
      });
    }
  };

  const handleSavePayment = async () => {
    if (!selectedAccount || !receivedAmount || !selectedInvoice) {
      toast.error('Please fill all required fields', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }

    const totalAmount = parseFloat(selectedInvoice.amount);
    const received = parseFloat(receivedAmount);
    const remainingBalance = totalAmount - received;

    if (received > totalAmount) {
      toast.error('Received amount cannot exceed total amount', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }

    try {
      const payload = {
        account_id: selectedAccount.value,
        user_id: currentUser.id,
        payment_status: paymentStatus,
        total_amount: totalAmount,
        selected_invoice_id: selectedInvoice.id,
        received_amount: received,
      };

      const response = await fetch(`${API_URL}/api/payments`, {
        method: 'POST',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.status === 201) {
        toast.success('Payment saved successfully!', {
          position: 'top-right',
          autoClose: 3000,
        });
        setShowModal(false);
        
        let headersList = {
          Accept: '*/*',
          'Content-Type': 'application/json',
        };
        let response = await fetch(`${API_URL}/api/invoice/update-status/${selectedInvoice?.id}`, {
          method: 'PUT',
          headers: headersList,
          body: JSON.stringify({ status: selectedStatusFor }),
        });
          let data = await response.json();
          window.location.reload();
      } else {
        toast.error(data.message || 'Failed to save payment', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Failed to save payment: ' + error.message, {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  function formatDateString(dateStr) {
    const date = new Date(dateStr);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  }

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      navigate(`/sign-in?id=${LOCATION_ID}&tk_id=${TOKEN}`);
      return;
    }
    setCurrentUser(user);
    const getActionsColumn = (data, type, row) => {
      if (currentUser?.roles?.role !== 'admin') {
        const actions = [];
        if (privileges?.invoice?.read) {
          actions.push(
            `<li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Invoice</a></li>
            <li><a style="cursor:pointer" class="dropdown-item payment-btn" data-id="${row.id}"><i class="ph ph-trash"></i>View Payments</a></li>
            `
          );
          if(row.status !== 'paid'){
            actions.push(`<li><a style="cursor:pointer" class="dropdown-item log-payment" data-id="${row.id}"><i class="ph ph-trash"></i>Make Payment</a></li>`)
          }
        }
        if (privileges?.invoice?.edit) {
          actions.push(
            `<li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Invoice</a></li>`
          );
        }
        if (privileges?.invoice?.delete) {
          actions.push(
            `<li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Invoice</a></li>`
          );
        }
        if (actions.length === 0) {
          return '<span>No actions available</span>';
        }
        return `
          <div class="dropdown">
            <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="ph ph-list"></i>
            </button>
            <ul class="dropdown-menu">
              ${actions.join('')}
            </ul>
          </div>
        `;
      } else {
        return `
          <div class="dropdown">
            <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="ph ph-list"></i>
            </button>
            <ul class="dropdown-menu">
              <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Invoice</a></li>
              <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Invoice</a></li>
              <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Invoice</a></li>
              <li><a style="cursor:pointer" class="dropdown-item log-payment" data-id="${row.id}"><i class="ph ph-trash"></i>Make Payment</a></li>
              <li><a style="cursor:pointer" class="dropdown-item payment-btn" data-id="${row.id}"><i class="ph ph-trash"></i>View Payments</a></li>
            </ul>
          </div>
        `;
      }
    };

    const getStatusColumn = (data, type, row) => {
      let badgeClass = "secondary"; // default
    
      switch (data?.toLowerCase()) {
        case "paid":
          badgeClass = "success";
          break;
        case "un-paid":
        case "unpaid":
          badgeClass = "danger";
          break;
        case "partially-paid":
          badgeClass = "warning";
          break;
      }
    
      return `<span class="badge bg-${badgeClass}">${data.charAt(0).toUpperCase() + data.slice(1)}</span>`;
    };

    const table = $('#dataTable').DataTable({
      data: jobsData,
      responsive: true,
      pageLength: 10,
      order: [[0, 'desc']],
      columns: [
        { data: 'id' },
        { data: 'invoice_number' },
        { data: 'customer_name' },
        {
          data: 'issue_date',
          render: function (data, type, row) {
            return `<span>${formatDateString(data)}</span>`;
          },
        },
        {
          data: 'due_date',
          render: function (data, type, row) {
            return `<span>${formatDateString(data)}</span>`;
          },
        },
        {
          data: 'totalAmount',
          render: function (data, type, row) {
            return `<span>${row.currency} ${parseFloat(data).toFixed(2)}</span>`;
          },
        },
        {
          data: 'status',
          render: getStatusColumn,
        },
        {
          data: null,
          render: getActionsColumn,
          title: 'Actions',
          orderable: false,
        },
      ],
    });

    $('#dataTable tbody').on('click', '.edit-btn', function () {
      const id = $(this).data('id');
      navigate(`/invoice-edit/${id}`);
    });

    $('#dataTable tbody').on('click', '.view-btn', function () {
      const id = $(this).data('id');
      navigate(`/invoice-preview/${id}`);
    });

    $('#dataTable tbody').on('click', '.delete-btn', function () {
      const id = $(this).data('id');
      handleDelete(id);
    });
    $('#dataTable tbody').on('click', '.log-payment', function () {
        const id = $(this).data('id');
        const invoice = jobsData.find((job) => job.id === id);
        setSelectedInvoice(invoice);
        fetchAccounts();
        fetchPaymentLogs(invoice?.id);
        setShowModal(true);
      
    });

    $('#dataTable tbody').on('click', '.payment-btn', function () {
      const id = $(this).data('id');
      
      navigate(`/invoice-payments/${id}`);
      // handleStatusChange(id);
    });

    $('#dataTable tbody').on('change', '.status-dropdown', function () {
      const id = $(this).data('id');
      const newStatus = $(this).val();
      
    });

    return () => {
      table.destroy(true);
    };
  }, [jobsData]);

  const accountOptions = accounts.map((account) => ({
    value: account.id,
    label: `${account.accountTitle} (${account.type}${account.accountNo ? ` - ${account.accountNo}` : ''})`,
  }));

  const remainingBalance = selectedInvoice && receivedAmount
    ? parseFloat(selectedInvoice.amount) - parseFloat(receivedAmount)
    : 0;

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Invoices</h5>
          <div className="col-md-6 text-end">
            <Link className="btn btn-info" to={'/create-invoice'}>
              Add New
            </Link>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="dataTable">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">InvoiceNo</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Issued Date</th>
              <th scope="col">Due Date</th>
              <th scope="col">Amount</th>
              
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>

      {showModal && (
  <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-lg">   {/* <-- make modal bigger */}
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">
            Record Payment for Invoice #{selectedInvoice?.invoice_number}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          {tableError && <div className="alert alert-danger">{tableError}</div>}

          {/* Accounts Dropdown */}
          <div className="mb-3">
            <label className="form-label">Select Account</label>
            <Select
              options={accountOptions}
              value={selectedAccount}
              onChange={setSelectedAccount}
              placeholder="Select an account"
            />
          </div>

          {/* Payment history */}
          {selectedAccount && (
            <div className="mb-3">
              <h6>Account Information</h6>
              {accounts
                .filter((acc) => acc.id === selectedAccount.value)
                .map((acc) => (
                  <div key={acc.id}>
                    <p><strong>Type:</strong> {acc.type}</p>
                    <p><strong>Account Title:</strong> {acc.accountTitle}</p>
                    {acc.accountNo && <p><strong>Account Number:</strong> {acc.accountNo}</p>}
                    {acc.bankName && <p><strong>Bank Name:</strong> {acc.bankName}</p>}
                  </div>
                ))}
            </div>
          )}

          <h6 className="mt-3">Payment History</h6>
          {paymentLogs.length === 0 ? (
            <p>No Payment History Found....</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Record By</th>
                  <th>Total Amount</th>
                  <th>Received Amount</th>
                  <th>Remaining Amount</th>
                </tr>
              </thead>
              <tbody>
                {paymentLogs.map((e, i) => (
                  <tr key={i}>
                    <td>{e?.userName}</td>
                    <td>{e?.total_amount}</td>
                    <td>{e?.received_amount}</td>
                    <td>{e?.remaining_balance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Amount section */}
          {(() => {
            const alreadyPaid = paymentLogs.reduce(
              (sum, log) => sum + parseFloat(log.received_amount || 0),
              0
            );
            const totalAmount = parseFloat(selectedInvoice?.amount || 0);
            const remainingBeforeThisPayment = totalAmount - alreadyPaid;
            const newRemaining =
              remainingBeforeThisPayment - parseFloat(receivedAmount || 0);

            return (
              <>
                <div className="mb-3">
                  <label className="form-label">Total Invoice Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={`${selectedInvoice?.currency} ${totalAmount.toFixed(2)}`}
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Remaining Balance</label>
                  <input
                    type="text"
                    className="form-control"
                    value={`${selectedInvoice?.currency} ${Math.max(newRemaining, 0).toFixed(2)}`}
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Received Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={receivedAmount}
                    onChange={(e) => setReceivedAmount(e.target.value)}
                    placeholder="Enter received amount"
                  />
                </div>

              
              </>
            );
          })()}

          {/* Payment status */}
          <div className="mb-3">
            <label className="form-label">Payment Status</label>
            <select
              className="form-select"
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e.target.value)}
            >
              <option value="CONFIRM">Confirmed</option>
              <option value="NOT_CONFIRM">Not Confirmed</option>
            </select>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSavePayment}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default InvoiceListLayer;